<template>
  <div>
    <el-card class="mtf-head">
      <div class="custom-flex-space-between">
        <div class="curMonth">
          <el-radio-group v-model="timeDimension" class="custom-elRadioGroup" text-color="#78bfcf" fill="#ffffff">
            <el-radio-button label="1">{{ $t('SeaFreight.CurrentMonth') }}</el-radio-button>
            <el-radio-button label="2">{{ $t('SeaFreight.CurrentQuarter') }}</el-radio-button>
            <el-radio-button label="3">{{ $t('SeaFreight.CurrentYear') }}</el-radio-button>
          </el-radio-group>
        </div>
        <!-- <div class="mtf1">
          <span>{{ '线路筛选' }}</span>
          <el-select v-model="circuitSelect" class="elSelect" size="small" :popper-append-to-body="true" @change="handleChange">
            <el-option v-for="(item,index) in selectList" :key="index" :value="item.value" :label="item.label" />
          </el-select>
        </div> -->
      </div>
      <el-divider />
    </el-card>
    <div v-if="jobType==='OE'">
      <OEStatistics
        :time-dimension.sync="timeDimension"
        :customer-code.sync="customerCode"
      />
    </div>
    <div v-if="jobType==='OI'">
      <OIStatistics
        :time-dimension.sync="timeDimension"
        :customer-code.sync="customerCode"
      />
    </div>
    <div v-if="jobType==='MM'">
      <MMStatistics
        :time-dimension.sync="timeDimension"
        :customer-code.sync="customerCode"
      />
    </div>
  </div>
</template>
<script>
import OIStatistics from './oiStatistics.vue'
import OEStatistics from './oeStatistics.vue'
import MMStatistics from  '@/views/mmTransportation/modules/mmStatistics.vue'
import i18n from '@/i18n/i18n'

export default {
  components: {
    OIStatistics,
    OEStatistics,
    MMStatistics
  },
  props: {
    jobType: {
      type: String,
      default: 'OE'
    },
    customerCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formData: {},
      /** 周期 */
      timeDimension: '1',
    }
  },
  computed: {},
  // watch: {
  //   jobType(newValue, oldValue) {
  //     if (newValue !== oldValue) {
  //       this.circuitSelect = this.jobType
  //     }
  //   }
  // },
  mounted() {
    // this.circuitSelect = this.jobType
  },
  methods: {
    handleChange() {
      this.$emit('update:jobType', this.circuitSelect)
    }
  }
}
</script>
<style scoped>
/* 公共样式提取至内部 开始*/
.custom-input {
  border: none;
  width: 200px;
}
.custom-input >>> input {
  border: none;
  background: #f6f6f8;
}
/* 公共样式提取至内部 结束 */

.mtf1 {
  margin-top: -1px;
  border-top: #fff;
}
.mtf-head {
  margin-top: -1px;
  border-top: #fff;
}
.mtf-head >>> .el-card__body {
  padding: 10px 20px 0px 20px !important;
}

.mt10 {
  margin-top: 10px;
}
.mt16 {
  margin-top: 16px;
}
.fw600 {
  font-weight: 600;
}
.minheight350 {
  min-height: 350px;
}
.border {
  border: 1px solid #e5e7eb;
}
.borderRadius {
  border-radius: 10px;
}
.dian::before {
  content: '';
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #58c6e4;
  border-radius: 50%;
  margin-right: 6px;
  margin-bottom: 2px;
}
.curMonth {
  padding: 4px 4px;
  background: #f6f6f8;
}
.elSelect {
  width: 180px;
  margin-left: 10px;
  border-radius: 8px;
}
</style>
